import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../context/ProtectedRoute';
import GrootbijgaardenDashboard from '../projects/ESID-24-031/pages/dashboard';
import GrootbijgaardenCustom from '../projects/ESID-24-031/pages/custom';
import GrootbijgaardenReport from '../projects/ESID-24-031/pages/report';

function GrootBijgaardennRoutes({setLoading, triggerAlert}) {
  return (
    <Routes>
      <Route path="dashboard" element={
        <ProtectedRoute project="esid-24-031">
          <GrootbijgaardenDashboard setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
      <Route path="custom" element={
        <ProtectedRoute project="esid-24-031">
          <GrootbijgaardenCustom setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
      <Route path="reports" element={
        <ProtectedRoute project="esid-24-031">
          <GrootbijgaardenReport setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default GrootBijgaardennRoutes;